/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { MediaImageType, PlayerMediaImage } from "../types";

/**
 * Finds an image by type from the images array.
 * Falls back to the first available image if the requested type is not found.
 */
export function getImageByType(
  images: PlayerMediaImage[] | undefined,
  type: MediaImageType,
): PlayerMediaImage | undefined {
  if (!images || images.length === 0) {
    return undefined;
  }

  return images.find((img) => img.ImageTypeCode === type) || images[0];
}

/**
 * Gets the URL of a Frame image, falling back to Highlights type.
 */
export function getFrameImageUrl(
  images: PlayerMediaImage[] | undefined,
): string | undefined {
  if (!images || images.length === 0) {
    return undefined;
  }

  const frame = images.find(
    (img) => img.ImageTypeCode === MediaImageType.Frame,
  );
  if (frame?.Url) {
    return frame.Url;
  }

  const highlights = images.find(
    (img) => img.ImageTypeCode === MediaImageType.Highlights,
  );
  return highlights?.Url;
}
